import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import TabArea from '@blade-sxp/task-management/components/tab-area.vue';
import RoiArea from '@blade-sxp/task-management/components/roi-area.vue';
import cascaderSelect from '@blade/common/components/device-cascader-select/index.vue';
import { createTask, taskDetail, updateTask, lablePerson } from '@blade-sxp/task-management/api/statistics/index';
import { getDeviceRegion, queryDeviceRtspPreviewAddress } from '@blade-sxp/task-management/api/creat-task/index';
import AlertNotification from '@blade-sxp/task-management/components/alert-notification.vue';
import { createTaskParams } from '@blade-sxp/task-management/api/creat-task/create-task-params';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { cloneDeep, compact, isEmpty } from 'lodash';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import { directionSet } from '@blade-sxp/task-management/utils/direction-set';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
import { QueueUpModule } from '@blade-sxp/task-management/store/queueUp';
const Service = { createTask, queryDeviceRtspPreviewAddress, taskDetail, getDeviceRegion, updateTask, lablePerson };
let CreateTask = class CreateTask extends Vue {
    isOpen = false;
    zoneId = '';
    twinRoi = {};
    selectImg = require('@blade-sxp/task-management/assets/select.png');
    submitParams = cloneDeep(createTaskParams);
    tabData = [
        { name: String(this.$t('modelType')), id: 1, type: 'modelType', roiType: 'switch', complete: true },
        { name: String(this.$t('roiArea')), id: 2, type: 'roiArea', roiType: 'polygon', complete: false },
        { name: String(this.$t('line')), id: 3, type: 'lines', roiType: 'lines', complete: false },
        { name: String(this.$t('markOnMap')), id: 4, type: 'markOnMap', roiType: 'polygon', complete: false },
        { name: String(this.$t('bodyFrame')), id: 5, type: 'bodyFrame', roiType: 'rect', complete: false },
    ];
    formData = {
        taskName: '',
        taskStatus: 'ENABLE',
        deviceId: '',
        tabData: this.tabData,
        getThreshold: '',
        remark: '',
    };
    isDetail = false;
    dataSource = [];
    taskTyep = '';
    shouldReset = false;
    polygonData = [];
    roiData = [];
    activeName = 'modelType';
    isSave = true;
    mapSource = [];
    aearActive = 0;
    canvasWidth = 738;
    canvasHeight = 415;
    polygonAreaLine = [];
    polygonRect = [];
    polygonArea = [];
    rtspUrl = '';
    options = setCustomOptions('polygon');
    optionsLine = setCustomOptions('line');
    optionsRect = setCustomOptions('rect');
    shouldFirst = 1;
    taskStatus = 'ENABLE';
    isError = false;
    isDisabled = false;
    flage = false;
    isDisableSave = {
        time: false,
        relus: false,
    };
    // formData rules
    get rules() {
        return {
            taskName: [{ required: true, message: `${this.$t('inputRule')}`, trigger: 'blur' }],
        };
    }
    deviceIdChange(val) {
        if (val) {
            this.getRtsp(val);
        }
        else {
            this.clearRoi();
            this.rtspUrl = '';
        }
    }
    onChangeTabData(val) {
        this.formData.tabData = val;
    }
    onChangeFormData(val) {
        if (this.taskTyep === 'edit') {
            this.shouldFirst++;
            if (this.shouldFirst === 5) {
                this.isSave = true;
                return;
            }
        }
        let result = val.tabData.every((item) => item.complete === true);
        if (val.taskName && result && !isEmpty(val.getThreshold)) {
            this.isDisableSave.relus = false;
        }
        else {
            this.isDisableSave.relus = true;
        }
    }
    onChnageSubmit(val) {
        const thresholdConfigs = val.alarmConfig.thresholdConfigs[0];
        const effectiveDates = thresholdConfigs.effectiveDates?.end ?? '';
        if (thresholdConfigs.effectivePeriod === 'CUSTOMIZE') {
            thresholdConfigs.effectiveTimes.some((item) => {
                if ((item.start || item.effectiveTimes?.length) && effectiveDates && thresholdConfigs.dayOfWeeks.length) {
                    this.isDisableSave.time = false;
                }
                else {
                    this.isDisableSave.time = true;
                }
            });
        }
        else {
            this.isDisableSave.time = false;
        }
    }
    isSaves(val) {
        if (!val.relus && !val.time) {
            this.isSave = false;
        }
        else {
            this.isSave = true;
        }
    }
    // 检测roi回显数据
    onChangePoly(val) {
        if (val.length > 0) {
            this.setData(val);
        }
        else {
            for (let value of this.tabData) {
                if (value.type === 'modelType') {
                    value.complete = true;
                }
                else {
                    value.complete = false;
                }
            }
        }
    }
    mounted() {
        const { id, type } = this.$route.query;
        this.isDetail = type === 'detail';
        if (!isEmpty(type) && type === 'detail') {
            this.isDisabled = true;
        }
        else {
            this.isDisabled = false;
        }
        if (id && id !== '') {
            this.getTaskDetail(id);
        }
        this.taskTyep = String(type);
        if (this.taskTyep === 'add') {
            this.flage = true;
        }
        if (this.taskTyep === 'copy' || this.taskTyep === 'add') {
            this.$route.meta.title = 'createQueueTask';
        }
        else if (this.taskTyep === 'detail') {
            this.$route.meta.title = 'lookQueue';
        }
        else {
            this.$route.meta.title = 'editQueueTask';
        }
    }
    beforedestroy() {
        QueueUpModule.updataEnableAttributesAnalysis(false);
    }
    returnSubmit() {
        this.$router.push('/tasklist');
    }
    // private editBtn() {
    //   const url = this.$route.path;
    //   const { id, taskType } = this.$route.query;
    //   this.$router.push({ path: url, query: { type: 'update', taskType, id } });
    //   this.isDisabled = false;
    //   this.isDetail = false;
    // }
    getDeviceRegion(deviceId, rtspUrl) {
        Service.getDeviceRegion(deviceId).then((res) => {
            if (!res.hasLinkedMap) {
                this.$alert(`${this.$t('hasLinkedMap', { camera: res.name })}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            if (res.zoneStatus !== 'ENABLE') {
                this.$alert(`${this.$t('status', { camera: res.name })}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            if (!res.hasUploadedMap) {
                this.$alert(`${this.$t('hasUploadedMap', { camera: res.name })}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            if (isEmpty(res.vertices)) {
                this.$alert(`${res.name} ${this.$t('noVertices')}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('know')}`,
                    confirmButtonClass: 'confirm-roi-tip',
                });
                this.formData.deviceId = '';
                return;
            }
            // this.submitParams.zoneId = Number(res.zoneId);
            this.rtspUrl = rtspUrl;
            this.zoneId = res.zoneId;
            this.twinRoi = res.vertices;
            Service.lablePerson(Number(deviceId)).then((res1) => {
                if (!res1) {
                    return;
                }
                let roiData = JSON.parse(res1[deviceId].roiData);
                this.polygonRect = [];
                if (roiData?.polygonData) {
                    for (let i of roiData.polygonData) {
                        // 框框
                        if (i.type === 'rect') {
                            this.polygonRect.push(i);
                        }
                    }
                }
                if (roiData?.titleList) {
                    roiData.titleList.forEach((item) => {
                        if (item.type === 'BODY') {
                            this.polygonRect = item.data;
                        }
                    });
                }
                if (this.polygonRect.length > 0) {
                    const index = this.tabData.findIndex((item) => item.roiType === 'rect');
                    this.tabData[index].complete = true;
                }
                // (this.$refs.tabArea as HTMLFormElement).goPrevious(0);
                if (this.submitParams.deviceTaskConfigs.length > 0) {
                    for (let value of this.submitParams.deviceTaskConfigs) {
                        value.deviceId = String(deviceId);
                    }
                }
            });
        });
    }
    changeComplete(e) {
        this.tabData[3].complete = e;
    }
    group(array, subGroupLength) {
        let index = 0;
        let newArray = [];
        while (index < array.length) {
            newArray.push(array.slice(index, (index += subGroupLength)));
        }
        return newArray;
    }
    // 任务详情
    async getTaskDetail(id) {
        await Service.taskDetail(id).then((res) => {
            if (res) {
                for (let value of this.tabData) {
                    value.complete = true;
                }
                let roipPolygonData = [];
                let lineObj = [];
                let status = '';
                if (res.status === 'ERROR') {
                    this.isError = true;
                    status = 'ENABLE';
                }
                else {
                    status = res.status;
                }
                this.formData = {
                    taskName: res.name,
                    taskStatus: status,
                    deviceId: res.deviceTaskConfigs[0].deviceId,
                    tabData: this.tabData,
                    getThreshold: res.alarmConfig.thresholdConfigs,
                    remark: res.remark,
                };
                const thresholdConfigs = res.alarmConfig.thresholdConfigs;
                let alarmConfig = this.submitParams?.alarmConfig;
                this.zoneId = res.deviceTaskConfigs[0].zoneId;
                this.submitParams.alarmConfig.thresholdConfigs[0].threshold.type = 'COUNTING';
                this.submitParams.alarmConfig.thresholdConfigs[0].threshold.unit = 'MINUTE';
                this.submitParams.alarmConfig.notifyConfig.frequency.unit = 'MINUTE';
                this.submitParams.alarmConfig.thresholdConfigs[0].levelConfig.unit = 'ABSOLUTE';
                this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels = compact(res.alarmConfig.notifyConfig.enabledAlarmLevels);
                this.submitParams.alarmConfig.notifyConfig.enabledTimeAlarmLevels = compact(res.alarmConfig.notifyConfig.enabledTimeAlarmLevels);
                this.submitParams.alarmConfig.notifyConfig.frequency.value = res.alarmConfig.notifyConfig.frequency.value;
                alarmConfig.thresholdConfigs = thresholdConfigs;
                const queueDate = res.deviceTaskConfigs?.find((item) => item.incidentType === 'INCIDENT_QUEUE_AREA');
                if (queueDate) {
                    const { queueAreaConfig } = queueDate || {};
                    QueueUpModule.updataEnableAttributesAnalysis(queueAreaConfig.enableAttributesAnalysis);
                }
                if (thresholdConfigs[0].effectiveDates[0]?.end) {
                    alarmConfig.thresholdConfigs[0].effectiveDates = thresholdConfigs[0].effectiveDates[0];
                }
                else {
                    alarmConfig.thresholdConfigs[0].effectiveDates = { start: '', end: '' };
                }
                let arr = [];
                thresholdConfigs[0]?.effectiveTimes?.forEach((item) => {
                    arr.push({ effectiveTimes: [item.start, item.end] });
                });
                if (arr.length === 0) {
                    arr = [{ effectiveTimes: ['', ''] }];
                }
                alarmConfig.thresholdConfigs[0].effectiveTimes = arr;
                this.flage = true;
                if (res.deviceTaskConfigs[0].roiData) {
                    // console.log('roi数据', JSON.parse(res.deviceTaskConfigs[0].roiData));
                    this.roiData = JSON.parse(res.deviceTaskConfigs[0].roiData).polygonData;
                    this.mapSource = JSON.parse(res.deviceTaskConfigs[0].roiData).mapSourceData;
                    this.getPolygonData(this.roiData);
                    for (let i in this.roiData) {
                        // 框框
                        if (this.roiData[i].type === 'rect') {
                            this.polygonRect.push(this.roiData[i]);
                        }
                        // 区域
                        if (this.roiData[i].type === 'polygon') {
                            roipPolygonData.push(this.roiData[i]);
                        }
                        // 横线
                        if (this.roiData[i].type === 'lines' || this.roiData[i].type === 'line') {
                            lineObj.push(this.roiData[i]);
                        }
                    }
                    // 最先显示区域和横线
                    this.dataSource = [...roipPolygonData, ...lineObj];
                    // 区域加横线
                    this.polygonAreaLine = [...roipPolygonData, ...lineObj];
                }
            }
        });
    }
    getRtsp(deviceId) {
        this.rtspUrl = '';
        if (this.shouldReset) {
            this.clearRoi();
        }
        Service.queryDeviceRtspPreviewAddress(String(deviceId)).then((resp) => {
            this.getDeviceRegion(deviceId, resp.rtspPreviewAddress);
            this.shouldReset = true;
        });
    }
    // 重置roi
    clearRoi() {
        for (let value of this.tabData) {
            if (value.type === 'modelType') {
                value.complete = true;
            }
            else {
                value.complete = false;
            }
        }
        this.$refs.tabArea.goPrevious(0);
        this.activeName = 'modelType';
        this.aearActive = 0;
        this.dataSource = [];
        this.mapSource = [];
        this.polygonRect = [];
        this.polygonArea = [];
        this.polygonAreaLine = [];
        this.twinRoi = {};
    }
    delectMapSource() {
        this.mapSource = [];
    }
    submit() {
        this.submitParams.taskType = 'QUEUE';
        this.submitParams.taskName = this.formData.taskName;
        this.submitParams.taskStatus = this.formData.taskStatus;
        this.submitParams.deviceTaskConfigs = [];
        this.submitParams.remark = this.formData.remark;
        let labelPersons = [];
        let bodyFrameData = [];
        const thresholdConfigs = this.submitParams.alarmConfig.thresholdConfigs;
        thresholdConfigs.forEach((item, index) => {
            if (!thresholdConfigs[0].effectiveDates || !thresholdConfigs[0].effectiveDates.start) {
                item.effectiveDates = [];
            }
            else {
                if (thresholdConfigs[0].effectiveDates instanceof Array) {
                    item.effectiveDates = thresholdConfigs?.[0].effectiveDates;
                }
                else {
                    item.effectiveDates = [thresholdConfigs?.[0].effectiveDates];
                }
            }
            item.effectivePeriod = thresholdConfigs?.[0].effectivePeriod ?? 'PERMANENT';
            item.dayOfWeeks = thresholdConfigs?.[0].dayOfWeeks;
            item.effectiveTimes = thresholdConfigs?.[0].effectiveTimes;
            item.effectiveTimes.forEach((time) => {
                time.start = time.effectiveTimes?.[0];
                time.end = time.effectiveTimes?.[1];
            });
        });
        if (this.polygonData && this.polygonData.length) {
            let roiMappingsArr = [];
            let objLine;
            let obj;
            for (let val of this.polygonData) {
                // 区域
                if (val.type === 'polygon') {
                    let polygonArr = val.vertices.slice(1);
                    let dataPolygon = {
                        rawRoi: {
                            id: this.taskId(),
                            name: val.id,
                            vertices: polygonArr,
                        },
                        twinRoi: {
                            id: this.taskId(),
                            name: this.mapSource[0].id,
                            vertices: this.mapSource[0].vertices.slice(1),
                        },
                    };
                    roiMappingsArr.push(dataPolygon);
                    obj = {
                        deviceId: this.formData.deviceId,
                        queueAreaConfig: {
                            roiMappings: roiMappingsArr,
                            enableAttributesAnalysis: QueueUpModule.enableAttributesAnalysis,
                        },
                        incidentType: 'INCIDENT_QUEUE_AREA',
                        labelPersons: [],
                        roiData: '',
                    };
                }
                // 横线
                if (val.type === 'lines' || val.type === 'line') {
                    objLine = {
                        deviceId: this.formData.deviceId,
                        crosslineStatisticConfig: {
                            crossLine: val.vertices,
                            directions: directionSet(val.direction),
                            roiId: this.taskId(),
                        },
                        incidentType: 'INCIDENT_CROSS_LINE',
                        labelPersons: [],
                        roiData: '',
                    };
                }
                // 框框
                if (val.type === 'rect') {
                    let labelPersonsObj = {};
                    labelPersonsObj.x = val.vertices[0].y > val.vertices[1].y ? val.vertices[1].y : val.vertices[0].y;
                    labelPersonsObj.y = val.vertices[0].y < val.vertices[1].y ? val.vertices[1].y : val.vertices[0].y;
                    labelPersons.push(labelPersonsObj);
                    bodyFrameData.push(val);
                }
            }
            let roiData = {
                polygonData: this.polygonData,
                mapSourceData: this.mapSource,
                titleList: [{ index: 4, text: 'Body Frame', type: 'BODY', isComplete: true, data: bodyFrameData }],
            };
            obj.roiData = JSON.stringify(roiData);
            objLine.roiData = JSON.stringify(roiData);
            if (obj) {
                this.submitParams.deviceTaskConfigs.push(obj);
            }
            if (objLine) {
                this.submitParams.deviceTaskConfigs.push(objLine);
            }
            if (this.submitParams.deviceTaskConfigs) {
                for (let value of this.submitParams.deviceTaskConfigs) {
                    value.zoneId = this.zoneId;
                    if (value.labelPersons) {
                        value.labelPersons = labelPersons;
                    }
                }
            }
        }
        // return;
        const data = this.submitParams;
        if (this.taskTyep === 'copy') {
            this.submitParams.taskId = '';
            Service.createTask(data).then((res) => {
                const tip = this.$i18n.t('submitTip');
                this.$message({
                    message: `${tip}`,
                    type: 'success',
                });
                localStorage.setItem('key', 'QUEUE');
                this.$router.push('/tasklist');
            });
        }
        else if (this.taskTyep === 'add') {
            Service.createTask(data).then((res) => {
                const tip = this.$i18n.t('submitTip');
                this.$message({
                    message: `${tip}`,
                    type: 'success',
                });
                this.$router.push('/tasklist');
            });
        }
        else {
            this.submitParams.taskId = this.$route.query.id;
            if (this.isError && this.formData.taskStatus === 'DISABLE') {
                this.submitParams.taskStatus = 'DISABLE';
            }
            else if (this.isError && this.formData.taskStatus === 'ENABLE') {
                this.submitParams.taskStatus = 'ERROR';
            }
            Service.updateTask(data).then((res) => {
                const tip = this.$i18n.t('submitTip');
                this.$message({
                    message: `${tip}`,
                    type: 'success',
                });
                this.$router.push('/tasklist');
            });
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    // 切换
    changeAreaActive(e) {
        this.aearActive = e;
        if (this.tabData[this.aearActive].type === 'bodyFrame') {
            this.dataSource = this.polygonRect;
        }
        else if (this.tabData[this.aearActive].type === 'markOnMap') {
            this.dataSource = this.polygonArea;
        }
        else {
            this.dataSource = this.polygonAreaLine;
        }
        // this.dataSource = [];
    }
    // 设置任务状态
    setData(val) {
        let rectArr = [];
        for (let value of this.tabData) {
            if (value.type !== 'markOnMap' && value.type !== 'modelType') {
                value.complete = false;
            }
        }
        for (let value of val) {
            switch (value.type) {
                case 'polygon':
                    this.tabData[1].complete = true;
                    break;
                case 'lines':
                    this.tabData[2].complete = true;
                    break;
                case 'line':
                    this.tabData[2].complete = true;
                    break;
                case 'rect':
                    rectArr.push(value);
                    if (rectArr.length < 3) {
                        this.tabData[4].complete = false;
                    }
                    else {
                        this.tabData[4].complete = true;
                    }
                    break;
            }
        }
    }
    // 获取 roi Polygon 数据   polygonAreaLine=[]  polygonRect=[] polygonArea=[] 更新提交的数据
    getPolygonData(val) {
        // this.polygonData = [];
        // 框框
        // 切换
        switch (this.tabData[this.aearActive].type) {
            case 'bodyFrame':
                this.polygonRect = val;
                break;
            default:
                this.polygonAreaLine = val;
                this.polygonArea = [];
                this.polygonArea = val.filter((item) => {
                    return item.type === 'polygon';
                });
        }
        this.polygonData = [...this.polygonAreaLine, ...this.polygonRect];
    }
    // 获取地图roi
    getMapPolygonData(e) {
        if (e) {
            this.mapSource = e;
            this.$message.success(this.$t('completeText').toString());
            // this.setMapData(this.roiData);
        }
    }
    getI18n(tip) {
        return this.$i18n.t(tip);
    }
    cancelSubmit() {
        this.$confirm(`${this.getI18n('cancelSubmitTip')}`, `${this.getI18n('tip')}`, {
            confirmButtonText: `${this.getI18n('confirm')}`,
            cancelButtonText: `${this.getI18n('cancel')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            customClass: 'task-confirm',
        })
            .then(() => {
            this.$router.push('/tasklist');
        })
            .catch(() => { });
    }
    // 阈值设置
    getThreshold(val) {
        this.submitParams.alarmConfig.thresholdConfigs = [];
        this.formData.getThreshold = val;
        let set = [];
        let setTime = [];
        set = compact(Array.from(new Set([...val.enabledAlarmLevels])));
        setTime = compact(Array.from(new Set([...val.enabledTimeAlarmLevels])));
        this.submitParams.alarmConfig.notifyConfig.enabledAlarmLevels = set;
        this.submitParams.alarmConfig.notifyConfig.enabledTimeAlarmLevels = setTime;
        this.submitParams.alarmConfig.notifyConfig.frequency.value = val.value;
        this.submitParams.alarmConfig.notifyConfig.frequency.unit = 'MINUTE';
        // 人數
        let minuteObj = {
            threshold: {
                type: 'COUNTING',
                unit: 'MINUTE',
                value: 0,
            },
            effectiveTimes: [
                {
                    end: '',
                    start: '',
                },
            ],
            levelConfig: {
                unit: 'ABSOLUTE',
            },
        };
        minuteObj.levelConfig.major = val.major;
        minuteObj.levelConfig.minor = val.minor;
        minuteObj.levelConfig.critical = val.critical;
        this.submitParams.alarmConfig.thresholdConfigs.push(minuteObj);
        // 時間
        let timeObj = {
            threshold: {
                type: 'TIMING',
                unit: 'MINUTE',
                value: 0,
            },
            effectiveTimes: [
                {
                    end: '',
                    start: '',
                },
            ],
            levelConfig: {
                unit: 'ABSOLUTE',
            },
        };
        timeObj.levelConfig.major = val.majorTime;
        timeObj.levelConfig.minor = val.minorTime;
        timeObj.levelConfig.critical = val.criticalTime;
        if (timeObj.levelConfig.major || timeObj.levelConfig.minor || timeObj.levelConfig.critical) {
            this.submitParams.alarmConfig.thresholdConfigs.push(timeObj);
        }
    }
    changeTabbar(val) {
        this.activeName = val;
    }
};
__decorate([
    Watch('formData.deviceId')
], CreateTask.prototype, "deviceIdChange", null);
__decorate([
    Watch('tabData', { immediate: true, deep: true })
], CreateTask.prototype, "onChangeTabData", null);
__decorate([
    Watch('formData', { immediate: true, deep: true })
], CreateTask.prototype, "onChangeFormData", null);
__decorate([
    Watch('submitParams', { deep: true })
], CreateTask.prototype, "onChnageSubmit", null);
__decorate([
    Watch('isDisableSave', { deep: true })
], CreateTask.prototype, "isSaves", null);
__decorate([
    Watch('polygonData', { immediate: true, deep: true })
], CreateTask.prototype, "onChangePoly", null);
CreateTask = __decorate([
    Component({
        name: 'CreateTask',
        components: {
            'roi-area': RoiArea,
            'cascader-select': cascaderSelect,
            'alert-notification': AlertNotification,
            'tab-area': TabArea,
            'valid-time': ValidTime,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    taskName: 'Task Name',
                    taskStatus: 'Activated',
                    camera: 'Camera',
                    roiArea: 'ROI Area',
                    line: 'Draw Line',
                    markOnMap: 'Mark on Map',
                    bodyFrame: 'Body Frame',
                    inputRule: 'Please enter task name',
                    submitTip: 'Operation successful',
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    know: 'I got it!',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'cancel',
                    completeText: 'ROI-1 complete',
                    hasUploadedMap: 'A map has not been uploaded to Area where {camera} resides. Therefore, the task cannot run normally. Please upload the map in map management',
                    hasLinkedMap: 'The task cannot run properly because {camera} has not been added to the map. Go to map management to add the device',
                    status: 'Area where {camera} resides is disabled, and the task cannot run normally. Please enable the area in map management',
                    noVertices: 'has not been punctuated in the map, and the task cannot run normally, please go punctuate this device on map in map management',
                    placeholderTip: 'You can select at least one camera for now',
                    modelType: 'Model Type',
                    save: 'Save',
                },
                zh: {
                    taskName: '任务名称',
                    taskStatus: '任务状态',
                    camera: '选择设备',
                    roiArea: 'ROI Area',
                    markOnMap: 'Mark on Map',
                    bodyFrame: 'Body Frame',
                    line: 'Draw Line',
                    inputRule: '请输入任务名称',
                    submitTip: '操作成功',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    know: '我知道了',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    hasUploadedMap: '{camera} 所在的区域 Check in Area 还未上传地图，任务无法正常运行，请前往地图管理中上传地图',
                    hasLinkedMap: '{camera} 还未在地图中添加，任务无法正常运行，请前往地图管理中添加设备',
                    status: '{camera} 所在的区域 Check in Area 已停用，任务无法正常运行，请前往地图管理中启用该区域',
                    noVertices: '还未在地图中标点，任务无法正常运行，请前往地图管理中标点此设备',
                    completeText: 'ROI-1 完成',
                    placeholderTip: '您现在至少可以选择一个摄像头',
                    modelType: 'Model Type',
                    save: '保存',
                },
            },
        },
    })
], CreateTask);
export default CreateTask;
